import { ChecklistSuggestion } from "Models/Checklists/ChecklistSuggestion";
import { ChecklistTemplate } from "Models/Checklists/ChecklistTemplate";
import { DataState } from "Models/Common/DataState";
import { ChecklistTemplateFilterState } from "./ChecklistTemplateFilterState";

export interface IChecklistTemplateState {
    suggestions: ChecklistSuggestion[];
    selectedSuggestion: ChecklistSuggestion;

    currentFilter: ChecklistTemplateFilterState;
    checklistTemplates: ChecklistTemplate[];
    totalChecklists?: number;
    isLoading: boolean;

    detailChecklistTemplates: { [taskTemplateId: number]: ChecklistTemplate };
    detailChecklistTemplateStates: { [taskTemplateId: number]: DataState };
    detailChecklistTemplateValidationErrors: { [taskTemplateId: number]: string[] };
}

export class ChecklistTemplateState implements IChecklistTemplateState {
    public suggestions: ChecklistSuggestion[] = [];
    public selectedSuggestion: ChecklistSuggestion;

    public currentFilter: ChecklistTemplateFilterState;
    public checklistTemplates: [];
    public isLoading: boolean = false;

    public detailChecklistTemplates = {};
    public detailChecklistTemplateStates = {};
    public detailChecklistTemplateValidationErrors = {};
}


// WEBPACK FOOTER //
// ./src/Store/ChecklistTemplates/ChecklistTemplateState.ts